const BOOTSTRAP_KEY = "externalInterviewV2Bootstrap";
const FLOW_STAGE_KEY = "externalInterviewV2Stage";

function safeParse(jsonValue) {
  if (!jsonValue) {
    return null;
  }
  try {
    return JSON.parse(jsonValue);
  } catch (error) {
    return null;
  }
}

export function saveBootstrapState(payload) {
  const bootstrap = {
    roomId: String(payload?.roomId || ""),
    userId: String(payload?.userId || ""),
    userType: String(payload?.userType || ""),
    rawUserType: String(payload?.rawUserType || ""),
    sessionId: String(payload?.sessionId || ""),
  };
  sessionStorage.setItem(BOOTSTRAP_KEY, JSON.stringify(bootstrap));
  return bootstrap;
}

export function readBootstrapState() {
  const fromSession = safeParse(sessionStorage.getItem(BOOTSTRAP_KEY));
  if (fromSession) {
    return fromSession;
  }
  return null;
}

export function clearBootstrapState() {
  sessionStorage.removeItem(BOOTSTRAP_KEY);
}

export function guidelinesAgreementKey(roomId, userId) {
  return `externalInterviewV2Guidelines:${roomId}:${userId}`;
}

export function markGuidelinesAgreed(roomId, userId) {
  if (!roomId || !userId) {
    return;
  }
  localStorage.setItem(guidelinesAgreementKey(roomId, userId), "true");
}

export function hasGuidelinesAgreement(roomId, userId) {
  if (!roomId || !userId) {
    return false;
  }
  return localStorage.getItem(guidelinesAgreementKey(roomId, userId)) === "true";
}

export function flowStageKey(roomId, userId) {
  return `${FLOW_STAGE_KEY}:${roomId}:${userId}`;
}

export function saveFlowStage(roomId, userId, stage) {
  if (!roomId || !userId || !stage) {
    return;
  }
  sessionStorage.setItem(flowStageKey(roomId, userId), String(stage));
}

export function readFlowStage(roomId, userId) {
  if (!roomId || !userId) {
    return "";
  }
  return sessionStorage.getItem(flowStageKey(roomId, userId)) || "";
}

export function clearFlowStage(roomId, userId) {
  if (!roomId || !userId) {
    return;
  }
  sessionStorage.removeItem(flowStageKey(roomId, userId));
}

export function clearFlowSession(roomId, userId) {
  clearBootstrapState();
  clearFlowStage(roomId, userId);
}
